import React from 'react';
import Style from './SectionHeader.module.scss';
import { Reveal } from './Reveal';

// Every section opens like an API call that succeeded.
export default function SectionHeader({ request, response = '200 OK', title }) {
    return (
        <Reveal>
            <div className={Style.header}>
                <p className={Style.request}>
                    <span className={Style.method}>GET</span> {request}
                    <span className={Style.arrow}>→</span>
                    <span className={Style.response}>{response}</span>
                </p>
                <h2 className={Style.title}>{title}</h2>
            </div>
        </Reveal>
    );
}
